export const environment = {
  staging: false,
  apiUrl: 'https://fastapi.fastglobe.in/api',
};
